import {TransportCardBalance} from '../../../models/api/transportCardBalance';

const mockResponse: TransportCardBalance = {
  cardNumber: 'card number',
  dateOfAnswer: '2022-03-04T05:56:43.896Z',
  balanceInRubles: 'Баланс временно недоступен',
  dateOfBalance: '2022-03-04T05:56:43.896Z',
  unwrittenBalance: {
    amountInRubles: 100,
    dateOfPayment: '2022-03-04T05:56:43.896Z',
  },
};

export default mockResponse;
